import { useState } from 'react'
import prepareTOTPRegistration from '../api/prepareTOTPRegistration'
import finishTOTPRegistration from '../api/finishTOTPRegistration'
import { apiRequest } from '../utils/apiRequest'
import {
  REGISTER,
  REGISTRATION_COMPLETE,
  START_REGISTRATION,
} from '../constants/mfa.setup.steps'

export function useSetupMFATOTP({ isFromSettings = false } = {}) {
  const [state, setState] = useState({
    step: START_REGISTRATION,
    isFromSettings,
    isProcessing: false,
    errorCode: null,
    registrationData: null,
  })

  const prepare = async () => {
    setState((s) => ({ ...s, isProcessing: true, errorCode: null }))
    try {
      const { totp_registration_uri: uri, totp_registration_token: token } =
        await apiRequest(prepareTOTPRegistration)
      setState((s) => ({
        ...s,
        isProcessing: false,
        registrationData: { uri, token },
        step: REGISTER,
      }))
    } catch (error) {
      setState((s) => ({ ...s, isProcessing: false, errorCode: error.message }))
    }
  }

  const finish = async ({ registrationToken, otp }) => {
    setState((s) => ({ ...s, isProcessing: true, errorCode: null }))
    try {
      await apiRequest(finishTOTPRegistration, {
        totp_registration_token: registrationToken,
        otp,
      })
      setState((s) => ({
        ...s,
        isProcessing: false,
        step: REGISTRATION_COMPLETE,
      }))
      return true
    } catch (error) {
      setState((s) => ({ ...s, isProcessing: false, errorCode: error.message }))
      return false
    }
  }

  return { ...state, prepare, finish }
}
